(function($){

    $('#bioModal').on('show.bs.modal', function (event) {
        var heading = $(event.relatedTarget).data('heading');
        //var biography = $(event.relatedTarget).data('bio');
        $(this).find('.bio-title').text(heading)
        //$(this).find('.bio-content').html(biography); //closest/nearest
        $(this).find('.bio-content').html($(event.relatedTarget).siblings('.bio-text').html());
    });

    $('p').each(function(){
        if($.trim($(this).text()) == "" && $(this).children().length == 0){
            $(this).hide();
        }
    });

    // function alignModal(){
    //     var modalDialog = $(this).find(".modal-dialog");
    //     modalDialog.css("margin-top", Math.max(0, ($(window).height() - modalDialog.height()) / 2));
    // }

    // $("#bioModal").on("shown.bs.modal", alignModal);
    
    // $(window).on("resize", function(){
    //     $(".modal:visible").each(alignModal);
    // });

})(jQuery);